import { usePdfBuilderStore } from "@/stores/pdfBuilder"
import type { PdfTemplateContent } from "@/types/pdfTemplate"
import { migrateTemplateItems } from "./migrateTemplateItems"

/**
 * 저장된 PDF 템플릿 내용을 스토어에 적용한다 — 편집 페이지(불러오기)와 홈 Quick Export 가 같은 함수를 쓴다.
 *
 * 편집 화면은 한 페이지에 이어 쓰는 구조다(페이지 탭·Add Page 제거, 2026-09-23). 예전에 여러 페이지로 저장한
 * 템플릿은 페이지 순서대로 아이템을 아래로 이어 붙여 한 페이지로 합친다 — 각 페이지의 아이템 y 에 앞 페이지들의
 * 아래끝(격자 행 수)을 더한다. 인쇄 시 페이지 나눔은 캡처가 A4 높이 단위로 자르며 처리한다.
 */
export function applyPdfTemplateContent(content: PdfTemplateContent) {
  const { pages: templatePages, paperConfig } = content
  const store = usePdfBuilderStore.getState()
  // 저장된 배치는 그 리포트 종류의 것이다 — 불러온다고 액티비티 리포트로 돌아가지 않는다 (2026-10-02)
  store.reset({ keepFilters: true })

  const pageId = usePdfBuilderStore.getState().pages[0]?.id
  if (!pageId) {
    return
  }

  const firstConfig = templatePages[0]?.config
  usePdfBuilderStore.getState().updatePageConfig(pageId, {
    ...(firstConfig ?? {}),
    orientation: firstConfig?.orientation ?? paperConfig.orientation,
    size: (firstConfig?.size ?? paperConfig.size) as "a4" | "letter" | "custom",
  })

  let offsetY = 0
  templatePages.forEach((templatePage) => {
    let pageBottom = 0
    // 옛 아이템(Action Table·Comparison·bar/line/point·단일 보기 Session Details)은 지금 모양으로 바꾸거나 지운다
    migrateTemplateItems(templatePage.items).forEach((item) => {
      usePdfBuilderStore.getState().addItem(pageId, { ...item, y: item.y + offsetY })
      pageBottom = Math.max(pageBottom, item.y + item.h)
    })
    offsetY += pageBottom
  })

  usePdfBuilderStore.getState().setCurrentPage(pageId)
  usePdfBuilderStore.getState().selectItem(null)
}
